module.exports = __webpack_public_path__ + "f07538c49565cb03e8016f1055060ba7.svg";